import React, { useEffect, useRef } from 'react'
import NavBar from '../NavBar.component'
import Slider from '../Slider.component'
import Footer from '../Footer.component'
import CustomScrollbar from '../CustomScrollbar.component'
import TabContent from '../TabContent.component'
import Clientele from '../Home/Clientele.component'
import Banner4 from "../../assets/Banner4.svg";
import Need6 from "../../assets/need-6.svg";
import NeedImg15 from "../../assets/NeedImg15.svg";
import thumbImg from '../../assets/SolutionsImage/vectorImages/Offline Tax Management/24.jpg'

let css = `
    .active-tab{
        color: #fff;
        background-color: #174997;
    }
    .active-tab img{
        filter: invert(1);
    }
`;

export default function OflineTaxManagement() {
    let scrollRef = useRef();
    const serviceBoxRef = useRef(null);

    // Scroll to the ServiceBox section when the page loads
    useEffect(() => {
        serviceBoxRef.current.scrollIntoView({ behavior: 'smooth' });
    }, []);
    return (
        <>
            <section className="">
                {/* NAVIGATION BAR */}
                <section className="">
                    <NavBar />
                </section>

                {/* NAV-CONTACT */}
                <section>{/* <NavContact/> */}</section>

                {/* HERO SLIDER */}
                <section>
                    <Slider images={[Banner4]} showDemoButton={true} />
                </section>

                {/* SOLUTION FOR YOUR UNIQUE BUSINESS NEEDS */}
                <section ref={serviceBoxRef}>
                    <section>
                        <style>{css}</style>
                        <div className="pt-16 custom-container">
                            <h1 className="text-center heading">
                                Solution for your unique business needs
                            </h1>
                            <p className="mt-3 text-sm text-center font-['montserrat']">
                                Explore our comprehensive range of solutions designed to
                                solve your specific challenges.
                            </p>
                        </div>
                        <div className="flex mb-12 mt-0 max-w-[80%] justify-center mx-auto items-center">
                            <div
                                className=" p-5 max-h-[770px]  overflow-y-auto scroll-smooth"
                                ref={scrollRef}
                            >
                                <TabContent
                                    index={5}
                                    icon={Need6}
                                    thumbnail={thumbImg}
                                    title={"Offline Tax Management "}
                                    content={[
                                        `
                                      Our Online and offline tax management software is designed to help individuals and businesses manage their taxes and finance efficiently. While both types of software serve the same purpose, they differ in how they operate and the benefits they offer.
                                      `,
                                        `
                                      Our Offline tax management software offers benefits such as offline access, increased security, and the ability to work on large files without internet limitations. Here we help legacy and B2B businesses record and manage all their databases securely.and more efficiently.
                                      `,
                                    ]}
                                    image={NeedImg15}
                                    captionWidth={"200px"}
                                />
                            </div>
                        </div>
                    </section>
                </section>

                {/* CLIENTELE */}
                <section>
                    <Clientele />
                </section>

                {/* FOOTER */}
                <section>
                    <Footer />
                </section>

                <CustomScrollbar />
            </section>
        </>
    )
}
